/**
 * Footer function
 */
export const formFunctions = () => {

	document.querySelectorAll( '.wpcf7-form select' ).forEach( el => {

		el.addEventListener( 'change', ( e ) => {

			e.target.blur();

		} );

	} );


	document.addEventListener( 'wpcf7beforesubmit', ( e ) => {

		e.target.querySelectorAll( '.wpcf7-form button[type="submit"]' ).forEach( btn => {

			btn.disabled = true;

		} );

	}, false );

	document.addEventListener( 'wpcf7submit', ( e ) => {

		e.target.querySelectorAll( '.wpcf7-form button[type="submit"]' ).forEach( btn => {

			btn.disabled = false;

		} );

	}, false );


}